<div class="st-page">
  <div class="st-page-head">
    <div class="fsr-head-left">
      <button type="button" class="sfr-icon-btn" (click)="goBack()"><i class="ri-arrow-left-line"></i></button>
      <div>
        <h1 class="st-title">{{ className }}</h1>
        <p class="st-subtitle">{{ 'feeOverdueReport' | translate }}</p>
      </div>
    </div>
    <div class="fsr-head-right" (click)="toggleInfoPopover()">
      <div class="fsr-total-label">{{ headerTotalLabel | translate }} <i class="ri-information-line"></i></div>
      <div class="fsr-total-amount" *ngIf="!fetchingStudentListData">{{ formatAmount(headerTotal) }}</div>
      <div class="fsr-total-skeleton" *ngIf="fetchingStudentListData"></div>

      <div class="fsr-info-popover" *ngIf="showInfoPopover" (click)="$event.stopPropagation()">
        {{ infoMessageKey | translate: { amount: formatAmount(headerTotal) } }}
      </div>
    </div>
  </div>

  <div class="st-tabs" *ngIf="!fetchingStudentListData; else tabsSkeleton">
    <div class="st-tab" [class.active]="activeTab === 'active'" (click)="setTab('active')">
      {{ 'activeStudent' | translate }} ({{ totalActiveStudentCount }})
    </div>
    <div class="st-tab" [class.active]="activeTab === 'deactivated'" (click)="setTab('deactivated')">
      {{ 'deactivatedStudent' | translate }} ({{ totalDeactivateStudentCount }})
    </div>
  </div>
  <ng-template #tabsSkeleton>
    <div class="fsr-tabs-skeleton"></div>
  </ng-template>

  <div class="st-tv-list" *ngIf="fetchingStudentListData">
    <div class="st-card fsr-skeleton-row" *ngFor="let s of [1,2,3,4,5,6,7,8,9]"></div>
  </div>

  <ng-container *ngIf="!fetchingStudentListData">
    <div class="st-card" *ngIf="students.length">
      <div class="st-list-row" *ngFor="let s of students" (click)="openStudent(s)">
        <div class="st-avatar">
          <img *ngIf="s.studentImage" [src]="s.studentImage" [alt]="s.studentName" />
          <ng-container *ngIf="!s.studentImage">{{ s.studentName.charAt(0) }}</ng-container>
        </div>
        <div class="st-list-text">
          <div class="st-list-title">{{ s.studentName }}</div>
          <div class="st-list-sub">{{ 'rollNo' | translate }}: {{ s.rollNumber }}</div>
        </div>
        <div class="sfr-amount">{{ formatAmount(pendingAmount(s)) }}</div>
      </div>
    </div>

    <div class="st-empty-state" *ngIf="!students.length">
      <i class="ri-file-list-3-line"></i> {{ 'feeNotAvailable' | translate }}
    </div>
  </ng-container>
</div>
